export const formatPrice = (price) => price?.toString().split('.').join(',');
